var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.332A6.675 6.675 0 0 0 1.332 8 6.675 6.675 0 0 0 8 14.668 6.675 6.675 0 0 0 14.668 8 6.675 6.675 0 0 0 8 1.332zM8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    fill: "url(#62i6kpqvta)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.348 8.665H8a.665.665 0 0 1-.666-.667V3.682c0-.37.297-.666.666-.666.37 0 .666.297.666.666v3.65h1.682c.369 0 .666.298.666.666a.665.665 0 0 1-.666.667z",
    fill: "url(#bpzdbvtsrb)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "62i6kpqvta",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bpzdbvtsrb",
    x1: 9.174,
    y1: 3.016,
    x2: 9.174,
    y2: 8.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.0a596fad6f2d4d2f126e52f13e3c906b.svg";
export { ForwardRef as ReactComponent };